import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IMeeting, defaultValue } from 'app/shared/model/meetinginfo.model';

const initialState: EntityState<IMeeting> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const meetingDataUrl = 'api/get/meetings/information';
const apiUrl = 'api/meetings';
const apiMeetingCreation = '/api/schedule/interview';
const adminInterviewDataUrladmin = '/api/admin/get/meetings/information';

// Actions

export const getEntityMeetingDetails = createAsyncThunk(
  'meeting/fetch_entity_meeting_details',
  async ({ page, size }: IQueryParams) => {
    const requestUrl = `${meetingDataUrl}?page=${page}&size=${size}&type=Meeting`;
    return axios.get<IMeeting>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);
export const getEntityInterviewDetails = createAsyncThunk(
  'meeting/fetch_entity_interview_details',
  async ({ page, size }: IQueryParams) => {
    const requestUrl = `${meetingDataUrl}?page=${page}&size=${size}&type=Interview`;
    return axios.get<IMeeting>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);
export const getEntityAdminInterviewDetails = createAsyncThunk(
  'meeting/fetch_entity_admin_interview_details',
  async ({ page, size }: IQueryParams) => {
    const requestUrl = `${adminInterviewDataUrladmin}?page=${page}&size=${size}&type=Interview`;
    return axios.get<IMeeting>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);

export const createEntityInterview = createAsyncThunk(
  'meeting/create_entity_interview',
  async (entity: IMeeting, thunkAPI) => {
    const result = await axios.post<IMeeting>(apiMeetingCreation, cleanEntity(entity));
    thunkAPI.dispatch(getEntityInterviewDetails({ page: 0, size: 20 }));
    return result;
  },
  { serializeError: serializeAxiosError }
);
export const partialUpdateEntityMeetings = createAsyncThunk(
  'meeting/partial_update_entitymeetings',
  async (entity: IMeeting, thunkAPI) => {
    const result = await axios.patch<IMeeting>(`${apiUrl}/${entity.id}`, cleanEntity(entity));
    thunkAPI.dispatch(getEntityInterviewDetails({}));
    return result;
  },
  { serializeError: serializeAxiosError }
);
// slice

export const MeetingInfoSlice = createEntitySlice({
  name: 'meetinginfo',
  initialState,
  extraReducers(builder) {
    builder

      .addCase(getEntityMeetingDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addCase(getEntityInterviewDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addCase(getEntityAdminInterviewDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addMatcher(isFulfilled(createEntityInterview), (state, action) => {
        state.updating = false;
        state.loading = false;
        state.updateSuccess = true;
        state.entity = action.payload.data;
      })
      .addMatcher(
        isPending(getEntityMeetingDetails, getEntityInterviewDetails, getEntityAdminInterviewDetails, createEntityInterview),
        state => {
          state.errorMessage = null;
          state.updateSuccess = false;
          state.loading = true;
        }
      );
  },
});

export const { reset } = MeetingInfoSlice.actions;

// Reducer
export default MeetingInfoSlice.reducer;
